import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../features/auth/authSlice";
import { getGroupage } from "../features/groupages/groupageSlices";
import GroupageItemCard from "../components/GroupageItemCard";
import { Box, Container, Stack, Typography } from "@mui/material";
import Navbar from "../components/Navbar";

const Groupage = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { groupage, isError, message, isLoading } = useSelector(
    (state) => state.groupages
  );

  useEffect(() => {
    if (isError && message === "Unauthorized") {
      dispatch(logout());
    }
  }, [isError, message, dispatch]);

  useEffect(() => {
    if (user) {
      setIsAdmin(user.role === "ADMIN" || user.role === "SUPERADMIN");
    }
  }, [user, dispatch]);

  useEffect(() => {
    console.log(id);
    dispatch(getGroupage(id));
  }, [user, id, dispatch]);

  return (
    <Box sx={{ minHeight: "100vh" }}>
      {user && <Navbar isAdmin={isAdmin} />}
      <Stack alignItems="center" justifyContent="center">
        <img id="searchLogo" src="/SKY2021.png" alt="SKYLOG v2" />
        <Container maxWidth="sm">
          {groupage && groupage.id ? (
            <GroupageItemCard groupage={groupage} expanded />
          ) : (
            <Typography textAlign={"center"}>Groupage not found</Typography>
          )}
        </Container>
      </Stack>
    </Box>
  );
};

export default Groupage;
